import React, { Component } from 'react';
import { Button, Form, Input, message, Table } from 'antd';
import moment from 'moment';
import { queryDoneTaskList } from '@api/workflow';
import getLink from './getLink';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    this.current = 1;
    this.loadData();
  }

  handleChange = pagination => {
    this.current = pagination.current;
    this.loadData();
  };

  loadData = () => {
    const limit = 15;
    queryDoneTaskList({
      start: this.current,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              current: this.current,
              pageSize: 15,
            },
          },
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.current = 1;
        this.condition = values;
        this.loadData();
      }
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.condition = '';
    this.props.form.resetFields();
    this.loadData();
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form
        layout="inline"
        onSubmit={this.handleSubmit}
        // style={{ textAlign: "right" }}
      >
        <FormItem label="搜索条件">
          {getFieldDecorator('condition')(<Input placeholder="请输入" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
          <Button style={{ marginLeft: 8, marginRight: '-16px' }} onClick={this.handleFormReset}>
            重置
          </Button>
        </FormItem>
      </Form>
    );
  };

  columns = () => {
    return [
      {
        title: '时间',
        dataIndex: 'cdate',
        key: 'cdate',
        render: (text, record, index) => (
          <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>
        ),
      },
      {
        title: '应用',
        dataIndex: 'instanceName',
        key: 'instanceName',
      },
      {
        title: '标题',
        dataIndex: 'title',
        render: (text, record) => {
          return getLink(record);
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;

    return (
      <div>
        <div className="tableListForm" style={{ marginBottom: '16px' }}>
          {this.renderSearchForm()}
        </div>
        <Table
          rowSelection={{}}
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/home/PageDone.js